<template>
  <el-dialog
    append-to-body
    width="500px"
    title="创建客户经理"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      class="staff-from"
      v-loading="loading"
      element-loading-text="加载中…"
      ref="elFormDom"
      label-width="100px"
      label-position="right"
      :model="form.data"
      :rules="form.rules"
      :size="subUnitSize"
    >
      <el-form-item label="姓名" prop="name">
        <el-input
          size="mini"
          v-model.trim="form.data.name"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="phone">
        <el-input
          size="mini"
          v-model.trim="form.data.phone"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input
          size="mini"
          v-model.trim="form.data.password"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>
    </el-form>

    <template #footer>
      <el-row type="flex" justify="end">
        <el-button @click="toggle(false)">取消</el-button>
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="confirm"
          >确定</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      visible: false,
      isChange: false,
      loading: false,
      form: {
        loading: false,
        data: {
          name: "",
          phone: "",
          password: "",
        },
        rules: {
          name: [{ required: true, message: "请输入", trigger: "change" }],
          phone: [{ required: true, message: "请输入", trigger: "change" }],
          password: [{ required: true, message: "请输入", trigger: "change" }],
        },
      },
      userOpt: [],
      userArr: [],
    };
  },
  methods: {
    reset(done) {
      this.$refs.elFormDom.resetFields();
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    // 提交
    confirm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          this.form.loading = true;
          let _params = {
            ...this.form.data,
          };
          this.$http
            .post("/admin/salesman/add", _params)
            .then((res) => {
              if (res.code === 1) {
                this.toggle(false);
                this.$emit("refresh");
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.addPerson__wrap {
  @include position($t: 0, $r: 0, $b: 0, $l: 0);
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.idPhoto .avatar {
  width: 100% !important;
}
.idPhoto .avatar-uploader-icon {
  width: 260px !important;
  height: 170px !important;
  line-height: 170px !important;
  border: 1px dashed #d9d9d9;
}
.onBtn-large {
  display: flex;
  justify-content: center;
}
</style>
